// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel___t7MI","choiceBoxes":"toolbarselects_choiceBoxes__gCW-E","simpleField":"toolbarselects_simpleField__2uDsi"};